<div class="ui primary button" [class.disabled]="!amount" (click)="proceedToCheckout()" [class.loading]="loading">
  Proceed to Checkout
</div>

<div class="ui inverted red segment" *ngIf="error">
  {{ error }}
</div>
